// src/components/AboutSection.jsx
import React, { useState } from "react";

// --- Accordion Data ---
const accordionData = [
  {
    title: "Strategic Precision",
    content: (
      <>
        <p className="mb-4 text-gray-600">
          At Riff Raff Tech Solutions, we turn ideas into scalable software
          products and services. Strategy isn’t just a plan — it’s actionable,
          measurable, and aligned with your business goals.
        </p>
        <ul className="space-y-3 text-sm text-gray-700">
          <li className="flex items-start">
            <span className="text-green-600 mr-2 mt-1">✓</span>
            Custom software solutions for service & product-based businesses.
          </li>
          <li className="flex items-start">
            <span className="text-green-600 mr-2 mt-1">✓</span>
            Process-driven approach ensuring efficiency and quality.
          </li>
          <li className="flex items-start">
            <span className="text-green-600 mr-2 mt-1">✓</span>
            Data-informed decisions to maximize growth and ROI.
          </li>
        </ul>
      </>
    ),
    isOpenDefault: true,
  },
  {
    title: "Senior-Led Expertise",
    content: (
      <p className="text-gray-600">
        Our experienced team oversees every project, ensuring excellence in both
        product development and client services. You get direct insights from
        industry professionals who have delivered impactful solutions.
      </p>
    ),
    isOpenDefault: false,
  },
  {
    title: "Tailored Solutions",
    content: (
      <p className="text-gray-600">
        We create solutions designed specifically for your organization’s needs.
        No off-the-shelf approaches — only strategies that align with your goals
        and market requirements.
      </p>
    ),
    isOpenDefault: false,
  },
  {
    title: "Long-Term Value",
    content: (
      <p className="text-gray-600">
        Our goal is to empower your team with sustainable capabilities. We
        provide knowledge transfer and tools that ensure success even after
        project completion.
      </p>
    ),
    isOpenDefault: false,
  },
  {
    title: "Transparent Partnership",
    content: (
      <p className="text-gray-600">
        We operate with complete transparency, providing clear communication,
        honest feedback, and a collaborative environment built on mutual trust.
      </p>
    ),
    isOpenDefault: false,
  },
];

// --- Accordion Item ---
const AccordionItem = ({ title, content, activeItem, setActiveItem }) => {
  const isOpen = activeItem === title;
  const toggleAccordion = () => setActiveItem(isOpen ? null : title);

  return (
    <div className="border-t border-gray-200">
      <button
        className="w-full py-6 flex justify-between items-center text-left text-xl font-medium text-gray-900 hover:text-gray-700 transition duration-200"
        onClick={toggleAccordion}
        aria-expanded={isOpen}
      >
        <span>{title}</span>
        <span
          className={`text-2xl transform transition-transform duration-300`}
        >
          {isOpen ? "−" : "+"}
        </span>
      </button>

      <div
        className={`overflow-hidden transition-all duration-500 ease-in-out ${
          isOpen ? "max-h-96 pb-6" : "max-h-0"
        }`}
      >
        {content}
      </div>
    </div>
  );
};

// --- Main About Section ---
const AboutSection = () => {
  const [activeItem, setActiveItem] = useState(accordionData[0].title);

  return (
    <section className="py-24 bg-gray-50 font-sans">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* LEFT COLUMN */}
          <div className="lg:pr-10">
            <span className="text-sm font-medium border border-gray-200 rounded-full px-2 py-1 text-gray-600 mb-4 inline-block">
              About us
            </span>
            <h2 className="text-5xl font-light leading-snug text-gray-900 mb-12">
              Strategic minds. <br /> Real-world impact
            </h2>
            <p className="text-lg text-gray-600 max-w-md mb-8">
              Riff Raff Tech Solutions is a service & product-based company
              delivering scalable software solutions. We help businesses
              innovate, optimize, and grow with practical strategies and
              technology-driven approaches.
            </p>
          </div>

          {/* RIGHT COLUMN: Accordion */}
          <div className="pt-20 lg:pt-0">
            <div className="border-b border-gray-200">
              {accordionData.map((item, index) => (
                <AccordionItem
                  key={index}
                  title={item.title}
                  content={item.content}
                  activeItem={activeItem}
                  setActiveItem={setActiveItem}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
